import useApi from '~/composables/useApi';
import { Feature, FeatureCategory, FeatureFilterInput } from './types';
import features from './features.gql';
import featureCategories from './featureCategories.gql';
import {
	useContext,
	ref
} from '@nuxtjs/composition-api';

interface FeatureOutput {
    items: Array<Feature>,
}

interface FeatureCategoryOutput {
    items: Array<FeatureCategory>,
}

export const useFeature = () => {
	const { query } = useApi();
	const { app } = useContext();
	const loadingFeatures = ref(false);

	const getFeatures = async (categoryId: number, productSku: number): Promise<FeatureOutput> => {
		loadingFeatures.value = true;
		const filter: FeatureFilterInput = {
			category_id: categoryId,
			product_sku: productSku,
		};

		const { data } = await query<{ features: FeatureOutput }>(features, { filter });
		const items = data?.features?.items ?? [];
		loadingFeatures.value = false;
		return {
			items: items,
		};
	};

	const getFeatureCategories = async (productSku: number): Promise<FeatureCategoryOutput> => {
		const filter = {
			product_sku: productSku,
		};
		const { data } = await query<{ featureCategories: FeatureCategoryOutput }>(featureCategories, { filter });
		const items = data?.featureCategories?.items ?? [];

		return {
			items: items,
		};
	};

	return {
		getFeatures,
		getFeatureCategories,
		loadingFeatures
	};
}

export default useFeature;
